import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "400px",
    height: "min-content",
  },
  content: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "40px",
    alignItems: "center",
  },
  information: {
    fontWeight: 600,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingTop: `${theme.spacing(3)}px`,
    borderRadius: theme.spacing(1),
    border: `1px solid ${grey[300]}`,
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    // Doubled to outrank `Form`'s own padding, which is injected later.
    "&&": {
      paddingBottom: theme.spacing(3),
    },
  },
  submit: {
    backgroundColor: theme.palette.primary.main,
    paddingLeft: `${theme.spacing(1)}px`,
    paddingRight: `${theme.spacing(1)}px`,
    height: "40px",
    width: "115px",
    fontWeight: 600,
  },
  submitDisabled: {
    backgroundColor: "rgba(0, 0, 0, 0.15) !important",
    color: "rgba(0, 0, 0, 0.4) !important",
  },
  field: {
    width: "352px",
    height: "48px",
  },
  title: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: `${theme.spacing(3)}px`,
    lineHeight: `${theme.spacing(3)}px`,
    marginTop: theme.spacing(2),
  },
  helperText: {
    marginTop: theme.spacing(3),
  },
  alert: {
    margin: theme.spacing(3, 3, 0),
  },
  googleButton: {
    width: "100%",
    padding: theme.spacing(3, 3, 0),
  },
  invalidInvite: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(4, 3, 3),
    textAlign: "center",
  },
  invalidInviteClose: {
    marginTop: theme.spacing(1),
  },
  googleAlert: {
    width: "100%",
    marginTop: theme.spacing(3),
    whiteSpace: "pre-line",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    // Doubled to outrank `Actions`' own padding, which is injected later.
    "&&": {
      paddingTop: theme.spacing(3),
    },
  },
  signInLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    marginTop: "auto",
    marginBottom: "auto",
  },
  errorBox: {
    width: "220px",
    height: "31px",
    padding: "8px",
    borderRadius: "4px",
    backgroundColor: "rgba(244, 67, 54, 0.1)",
    verticalAlign: "middle",
  },
  errorText: {
    fontStyle: "normal",
    fontSize: "10px",
    lineHeight: "15px",
    textAlign: "center",
    weight: 400,
    display: "flex",
    alignItems: "center",
    color: theme.palette.error.main,
  },
}));

export default useStyles;
